



















































import { Vue, Component } from "vue-property-decorator";
import company, { CompanyListParams } from "@/getinfo-api/company";
import {
  CompaniesList as ICompaniesList,
  Company as ICompany,
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import { uniqBy } from "lodash";
import { AxiosError } from "axios";
import CustomTable from "@/components/form/CustomTable.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { Disk, DiskList } from "@/api-v2/files/models";
import disksList, { DiskApiListParams } from "@/getinfo-api/fileManagerDisks";
import Modal from "@/components/form/Modal.vue";
import CField from "@/components/form/CField.vue";
import AdminControlTableItem from "@/components/admin/AdminControlTableItem.vue";
import UsersListView from "@/views/admin/users/UsersListView.vue";
import AdminPasswordValidatorSettings from "@/components/admin/AdminPasswordValidatorSettings.vue";
import StatusProfileAdminControl from "@/views/admin/StatusProfileAdminControl.vue";

@Component({
  components: {
    StatusProfileAdminControl,
    AdminPasswordValidatorSettings,
    UsersListView,
    AdminControlTableItem,
    CField,
    Modal,
    CustomTableCol,
    CustomTableItem,
    CustomButton,
    CBlock,
    CustomTable
  }
})
export default class AdminControl extends Vue {
  companies: Array<ICompany> = [];
  disks: Array<Disk> = [];
  limit: number = 15;
  offset: number = 0;
  companiesCount!: number;
  showSpinner: boolean = false;
  data() {
    return {
      companiesCount: undefined,
      choosedDisk: undefined
    };
  }

  getDisk(id: string) {
    let index = this.disks.findIndex(el => el.id === id);
    return this.disks[index];
  }

  showMoreCompanies() {
    this.offset += this.limit;
    this.getCompanies(this.offset);
  }

  getDisks(ids: Array<string>) {
    let params: DiskApiListParams = {
      ids: ids
    };
    disksList(params).then((res: { data: DiskList }) => {
      this.disks = [...this.disks, ...res.data.items];
      this.disks = uniqBy(this.disks, "id");
    });
  }

  getCompanies(offset: number = 0) {
    let params: CompanyListParams = {
      limit: 15,
      offset: offset
    };

    company(params)
      .then((res: { data: ICompaniesList }) => {
        if (res.data) {
          this.companiesCount = res.data.count;
          res.data.companies.forEach((element: ICompany) => {
            this.companies.push(element);
          });
          this.companies = uniqBy(this.companies, "id");
          this.getDisks(
            res.data.companies.map(el => (el.diskId ? el.diskId : ""))
          );
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }
  created() {
    this.getCompanies();
  }
}
